import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { ChartConfig } from '../../../types';
import { CHART_STYLE, formatDataValue, analyzeDecimals } from './chartStyles';

interface DonutChartViewProps {
  data: Record<string, unknown>[];
  config: ChartConfig;
}

/**
 * Donut chart for Discrete=1 + Numeric=1 with cardinality ≤ 5 (Rule 3a).
 */
export function DonutChartView({ data, config }: DonutChartViewProps) {
  const nameKey = config.xAxis ?? '';
  const valueKey = typeof config.yAxis === 'string' ? config.yAxis : config.yAxis?.[0] ?? '';
  const { hasDecimals, allSmall } = analyzeDecimals(data, valueKey);

  const renderLabel = (props: { name?: string; value?: number; percent?: number }) => {
    const name = props.name ?? '';
    const percent = props.percent ?? 0;
    const label = name.length > 10 ? `${name.slice(0, 10)}...` : name;
    return `${label} (${(percent * 100).toFixed(0)}%)`;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          dataKey={valueKey}
          nameKey={nameKey}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={100}
          paddingAngle={2}
          label={renderLabel}
          labelLine={{ strokeWidth: 1 }}
          style={{ fontSize: CHART_STYLE.fontSize.dataLabel }}
        >
          {data.map((_, index) => (
            <Cell key={index} fill={CHART_STYLE.colors[index % CHART_STYLE.colors.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={CHART_STYLE.tooltip}
          formatter={(value) => [formatDataValue(Number(value ?? 0), hasDecimals, allSmall), valueKey]}
        />
        <Legend wrapperStyle={{ fontSize: CHART_STYLE.fontSize.legend }} />
      </PieChart>
    </ResponsiveContainer>
  );
}
